import { QuestionIconStyles } from './QuestionIconStyles'
import React from 'react'
// import { QuestionIconProps } from './types/QuestionIconProps'

export const QuestionIcon = (): JSX.Element => {
  return <div className={`QuestionIcon ${QuestionIconStyles}`}>?</div>
}
